// Navbar.jsx

import React, { useState, useEffect, useRef } from "react";
import { Menu, Icon, Input, Button, Image, Grid } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../styles/DataconsoleNavbar.css";

const DataconsoleNavbar = ({
  setToggle,
  navTitle,
  type,
  handleOpenDocUpload,
  handleDatasetDocUpload,
  handleDatasetUrlUpload,
  handleDatasetUserUpload,
  showDatasetCount,
  NavbarCollapse,
  onDataFromChild,
  openDocList,
  openuserList,
  OpenDatasetUserList,
  OpenDatasetDocList,
  OpenRetrievalParam,
  handleOpenDocList,
  isAssistantDataset: isAssistantDatasetProp, 
}) => {
  const isMounted = useRef(true);
  const navBarTitle = navTitle || "Q&A";
  const [inputValue, setInputValue] = useState("");
  const [datasetInputValue, setDatasetInputValue] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isAssistantDataset, setIsAssistantDataset] = useState(false); // State for isAssistantDataset

  const { datasetUserListData, datasetUserListDataStatus } = useSelector(
      (state) => state.datasetUserList || {}
    );
    
  const toggleVisibility = () => {
    setIsVisible(prevState => !prevState);
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value.toLowerCase());
    onDataFromChild(event.target.value.toLowerCase());
  };

  const handleDatasetInputChange = (event) => {
    setDatasetInputValue(event.target.value.toLowerCase());
    onDataFromChild(event.target.value.toLowerCase());
  };

  useEffect(() => {
    if (isMounted.current) {
      setInputValue("");
      setDatasetInputValue("");
      onDataFromChild("");
  
      // Check if datasetUserListData is undefined
      if (!datasetUserListData) {
        // Use the prop value if datasetUserListData is undefined
        if (typeof isAssistantDatasetProp !== "undefined") {
          setIsAssistantDataset(isAssistantDatasetProp);
        }
      } else if (datasetUserListData && datasetUserListData.isAssistantDataset !== undefined) {
        // Use datasetUserListData.isAssistantDataset if available
        setIsAssistantDataset(datasetUserListData.isAssistantDataset);
      }
    }
  }, [isMounted, datasetUserListData, isAssistantDatasetProp]);

  const navigate = useNavigate();

  const handleBack = async () => {
    navigate(`/dataconsole`);
  };

  return (
    <Menu fixed="top" className="navbar" borderless >
      <Menu.Menu
        className={`${!NavbarCollapse ? "" : "navbar-collapse document-navbar"
          }`}
      >
        {/* Mobile View  and desktop view*/}
        {!NavbarCollapse ? (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left">
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                {type === "data_console" && (
                  <>
                    <Image src="/images/data-console.svg" alt="Data Console" />
                  </>
                )}
                {type === "add_doc" && (
                  <>
                    <Image
                      className="backButton"
                      onClick={handleBack}
                      src="/images/Back.svg"
                      alt="Back Button"
                    />
                    <Image
                            src={isAssistantDataset ? "/images/assistants.png" : "/images/datasets.png"}
                            alt={isAssistantDataset ? "Assistant" : "Datasets"}
                            style={{ height: "24px", width: "28px" }}
                          />
                  </>
                )}
                <label>{navBarTitle || "Default"}</label>
              </Menu.Item>
            </React.Fragment>
            {type === "data_console" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showDatasetCount || 0} Datasets</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchMobile"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder=" "
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchMobile">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>

                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}
            {type === "add_doc" && (
              <>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="addSearchMobile"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder=" "
                      data-cy="document-users-search-input"
                    />
                    <label htmlFor="addSearchMobile">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                </Menu.Item>
              </>
            )}
          </Grid>
        ) : (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left-dataconsole">
                {type === "data_console" && (
                  <>
                    {/* Mobile view */}
                    <div onClick={setToggle} className="mobile-sidebar-icon">
                      <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                    </div>
                    {/* Mobile view end */}
                    <Image src="/images/data-console.svg" alt="Data Console" />
                  </>
                )}
                {type === "add_doc" && (
                  <>
                    <Image
                      className="backButton"
                      onClick={handleBack}
                      src="/images/Back.svg"
                      alt="Back Button"
                    />
                    {/* Mobile view */}
                    <div onClick={setToggle} className="mobile-sidebar-icon">
                      <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                    </div>
                    {/* Mobile view end */}
                    <Image
                                src={isAssistantDataset ? "/images/assistants.png" : "/images/datasets.png"}
                                alt={isAssistantDataset ? "Assistant" : "Datasets"}
                                style={{ height: "24px", width: "28px" }} // Set height and width to icon size
                              />        
                       </>
                            )}
                            <label>
                              {navBarTitle.length < 25
                              ? navBarTitle
                              : navBarTitle.slice(0, 24) + "..." || "Default"}
                            </label>
                            </Menu.Item>
                          </React.Fragment>
                          {/*Desktop landing Page */}
            {type === "data_console" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showDatasetCount || 0} Datasets</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchDesktop"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder=""
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchDesktop">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}
            {type === "add_doc" && (
              <>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="addSearchDesktop"
                      value={datasetInputValue}
                      onChange={handleDatasetInputChange}
                      placeholder=""
                      data-cy="document-users-search-input"
                    />
                    <label htmlFor="addSearchDesktop">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {/* <div className="dataset-details-menu-item-tab">
                    <span
                      onClick={openDocList}
                      className={
                        OpenDatasetDocList
                          ? "active-docu-box details-doc-title"
                          : "details-doc-title"
                      }
                    >
                      Documents
                    </span>
                    <span
                      onClick={openuserList}
                      className={
                        OpenDatasetUserList
                          ? "active-docu-box details-users-title"
                          : "details-users-title"
                      }
                    >
                      Users
                    </span>
                  </div> */}
                  <div className="dataset-upload-button">
                    {OpenDatasetDocList ? (
                      <><Button
                        onClick={toggleVisibility}
                        className="mobile-button-data-console"
                        data-cy="add-document-link-button"
                        style={{ marginLeft: "-2vw" }}>
                        <div
                          className="button-data-console-parent"
                          data-cy="button-data-console-parent"
                          style={{
                            flexDirection: "row-reverse"
                          }}>
                          <Image
                            src="/images/drop-down.svg"
                            alt="Add new Document"
                            className="dropdown-icon"
                            style={{ marginLeft: '5px', marginRight: '0px !important' }} />
                          <span style={{marginLeft:'8px'}}>Add</span>
                        </div>
                      </Button>
                        {isVisible && (
                          <div
                            className="floating-box"
                            style={{
                              border: "1px solid #ccc",
                              backgroundColor: "white",
                              // padding: "10px",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              borderRadius: "4px",
                              display: "flex",
                              flexDirection: "column",  // Ensures items are stacked vertically
                              gap: "10px",  // Adds spacing between the items
                              marginTop: "10px",
                              // width: "fit-content",
                            }}
                          >
                            <ul style={{ listStyleType: "none", padding: "0", margin: "0" }}>
                              <li
                                onClick={() => {
                                  handleDatasetDocUpload();
                                  toggleVisibility();
                                }}
                                data-cy="add-document-link"
                                style={{
                                  padding: "10px",
                                  backgroundColor: "#f9f9f9", // Optional, for better visual separation
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #ccc",
                                }}
                              >
                                Files
                              </li>
                              <li
                                onClick={() => {
                                  handleDatasetUrlUpload();
                                  toggleVisibility();
                                }}
                                data-cy="add-url-link"
                                style={{
                                  padding: "10px",
                                  backgroundColor: "#f9f9f9", // Optional, for better visual separation
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #ccc",
                                }}
                              >
                                Links
                              </li>
                            </ul>
                          </div>
                        )}
                      </>



                    ) : (
                      OpenDatasetUserList && (
                        <Button
                          onClick={handleDatasetUserUpload}
                          className="mobile-button-data-console"
                          data-cy="add-document-link"
                        >
                          <div
                            className="button-data-console-parent"
                            data-cy="button-data-console-parent"
                          >
                            <Image
                              src="/images/white-base-icons.svg"
                              alt="Add new Document"
                            />
                            Assign User
                          </div>
                        </Button>
                      )
                    )}
                  </div>
                </Menu.Item>
              </>
            )}
          </Grid>
        )}
      </Menu.Menu>

      {/* Right-aligned content */}
      <Menu.Menu position="right">
        <React.Fragment>
        {type === "data_console" && (
  <Menu.Item className="hide-add-dataset-button-desktop">
    <Button
                  primary
                  onClick={handleOpenDocUpload}
                  className="button-data-console"
                  data-cy="add-dataset-btn-link"
                  style={{ display: 'flex', alignItems: 'center',justifyContent: 'center'}} // ensures children are aligned
                >
                  <Image
                    src="/images/white-base-icons.svg"
                    alt="Add new Dataset"
                  />
                  <span>Add new Dataset</span>
                </Button>
  </Menu.Item>
)}
          {/* <Menu.Item position="right">
            <img
              src="/images/filter.svg" // Using the imported delete image
              alt="Vie More"
              // onClick={() => handleDelete(row.id)}
              style={{ cursor: "pointer" }}
            />
          </Menu.Item> */}
        </React.Fragment>
      </Menu.Menu>
    </Menu>
  );
};

export default DataconsoleNavbar;
